module.exports = __webpack_public_path__ + "static/media/stats-flag-gold.780728e6.svg";